import { useState } from 'react';
import { useUser } from '../contexts/UserContext';

const Login = ({ onSwitchToRegister, onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useUser();

  async function handleSubmit(e) {
    e.preventDefault();
    if (loading) return;

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      if (onLoginSuccess) onLoginSuccess();
    } catch (err) {
      setError(err.message || 'Échec de la connexion. Vérifiez vos identifiants.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="cb-auth-page">
      <div className="cb-auth-panel">
        <div className="cb-auth-mark" aria-hidden="true">CB</div>
        <h2 className="text-center">Heureux de vous retrouver</h2>
        <p className="cb-auth-intro">Connectez-vous pour reprendre votre préparation là où vous l’aviez laissée.</p>

        {error && <div role="alert" className="cb-auth-error">{error}</div>}

        <form onSubmit={handleSubmit} aria-busy={loading}>
          <div>
            <div>
              <label htmlFor="cb-login-email" className="block text-xs font-semibold mb-2 text-primary">Adresse e-mail</label>
              <input id="cb-login-email" type="email" className="text-primary" required autoComplete="email"
                placeholder="votre@email.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label htmlFor="cb-login-password" className="block text-xs font-semibold mb-2 text-primary">Mot de passe</label>
              <input id="cb-login-password" type="password" className="text-primary" required autoComplete="current-password"
                placeholder="Votre mot de passe" value={password}
                onChange={(e) => setPassword(e.target.value)} />
            </div>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Connexion en cours…' : 'Accéder à mon espace'}
          </button>
        </form>
        <p className="cb-auth-switch">
          Vous découvrez ConcoursBF ?
          <button type="button" onClick={onSwitchToRegister}>Créer un compte</button>
        </p>
      </div>
    </div>
  );
};

export default Login;
